export class PagingWrapper<T> {
  constructor(public items: T[], public totalCount: number) {}
}

// export interface PagingWrapperNew<T>
// {
//     data: NewPagingWrapper<T>;
// }
export interface NewPagingWrapper<T> {
  items: T[];
  totalCount: number;
}
